/**
 * An inline error alert the operator can put away.
 *
 * Mutation errors (TanStack `mutation.error`) persist until the NEXT
 * attempt — correct when the retry happens right here, but some failures
 * send the operator elsewhere to fix the cause (set an end date on the
 * student, extend the cohort), and the alert would otherwise sit on the
 * page forever with no way to clear it. Wire `onDismiss` to the
 * mutation's `reset()`.
 *
 * Errors only. A confirmation needs no dismiss — it is replaced by the
 * next action or leaves with the page.
 */
import { Icon, Notice } from '@speaking-coach/ui'
import { cn } from '../components/ui/cn'

export function DismissibleAlert({
  message,
  onDismiss,
  className,
}: {
  message: string | null
  onDismiss: () => void
  className?: string
}): JSX.Element | null {
  if (message === null) return null
  return (
    <Notice variant="danger" className={cn('mb-3', className)}>
      <div className="flex items-start justify-between gap-3">
        <span>{message}</span>
        <button
          type="button"
          aria-label="Dismiss"
          onClick={onDismiss}
          className="text-text-faint hover:text-text-primary"
        >
          <Icon name="close" />
        </button>
      </div>
    </Notice>
  )
}
